import { FocusEvent } from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

export default function TextInputWithIcon(props: {
  fieldName: string;
  label: string;
  type?: string;
  control: Control<any, any>;
  errors: FieldErrors<any>;
  fontSize?: number;
  width?: number | string;
  size?: "small" | "medium";
  style?: React.CSSProperties;
  required?: boolean;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  startIcon: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
}) {
  const { fieldName, control, fontSize, errors, width, label, disabled } =
    props;
  const errorMessage = (
    typeof errors[fieldName]?.message === "string"
      ? errors[fieldName]?.message
      : undefined
  ) as string | undefined;
  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <TextField
          value={field.value ?? ""}
          disabled={disabled}
          label={label}
          style={props.style}
          size="small"
          type={props.type ?? "text"}
          error={!!errors[fieldName]}
          helperText={errorMessage}
          required={props.required}
          onBlur={props.onBlur}
          sx={{
            width: width ?? "200px",
            color: "#222D35",
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              height: "42px",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
            },
          }}
          InputProps={{
            style: {
              fontSize: fontSize ?? 14,
            },
            startAdornment: (
              <InputAdornment position="start" sx={{ color: "#8B9095" }}>
                {props.startIcon}
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end" sx={{ color: "#8B9095" }}>
                {props.endIcon}
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { fontSize: fontSize ?? 14 },
          }}
          onChange={(e) => {
            field.onChange(e);
          }}
        />
      )}
    />
  );
}
